import ReactDOM from 'react-dom/client';
import moment from 'moment';
import 'moment/locale/ru';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { RecoilRoot } from 'recoil';
import { RoutingUrls } from 'common/const';
import {
  PageMain,
  PageAuth,
  PagePassengers,
  PageTrips,
  PageBooking,
  PageTickets,
  PageError,
  PageTicket,
  PageSettings,
} from './pages';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.scss';

moment.locale('ru');

const router = createBrowserRouter([
  {
    path: RoutingUrls.Main,
    element: <PageMain />,
  },
  {
    path: RoutingUrls.Auth,
    element: <PageAuth />,
  },
  {
    path: RoutingUrls.Passengers,
    element: <PagePassengers />,
  },
  {
    path: RoutingUrls.Trips,
    element: <PageTrips />,
  },
  {
    path: RoutingUrls.Booking,
    element: <PageBooking />,
  },
  {
    path: RoutingUrls.Tickets,
    element: <PageTickets />,
  },
  {
    path: RoutingUrls.Error,
    element: <PageError />,
  },
  {
    path: RoutingUrls.Ticket,
    element: <PageTicket />,
  },
  {
    path: RoutingUrls.Settings,
    element: <PageSettings />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <RecoilRoot>
    <RouterProvider router={router} />
  </RecoilRoot>
);
